const QualitySection = () => {
  return (
    <section className="quality-stability-section">
      <div className="container">
        <div className="quality-stability-content text-center">
          <h2 className="section-title">坚守品质与稳定，不负每一份信赖</h2>
          <p className="section-subtitle">
            日益增多的智能体开发者选择我们的插件，品质、稳定、及时响应这三大支柱是我们稳固的基石
          </p>
          <div className="quality-metrics-row">
            <div className="quality-metric-item">
              <div className="quality-metric-number">
                12k+<span className="metric-plus">+</span>
              </div>
              <div className="quality-metric-label">智能体</div>
            </div>
            <div className="quality-metric-item">
              <div className="quality-metric-number">
                1600w+<span className="metric-plus">+</span>
              </div>
              <div className="quality-metric-label">调用量</div>
            </div>
            <div className="quality-metric-item">
              <div className="quality-metric-number">
                1w+<span className="metric-plus">+</span>
              </div>
              <div className="quality-metric-label">智能体构建师</div>
            </div>
          </div>
        </div>
      </div>
      <div className="quality-section-decorations">
        {/* <div className="quality-decoration quality-decoration-1"></div> */}
        {/* <div className="quality-decoration quality-decoration-2"></div> */}
        <div className="quality-decoration quality-decoration-3"></div>
        <div className="quality-grid-lines"></div>
        <div className="quality-particles">
          <div className="quality-particle quality-particle-1"></div>
          <div className="quality-particle quality-particle-2"></div>
          <div className="quality-particle quality-particle-3"></div>
          <div className="quality-particle quality-particle-4"></div>
          <div className="quality-particle quality-particle-5"></div>
          <div className="quality-particle quality-particle-6"></div>
          <div className="quality-particle quality-particle-7"></div>
          <div className="quality-particle quality-particle-8"></div>
        </div>
      </div>
    </section>
  );
};

export default QualitySection;
